import { lazy, Suspense } from 'react';

const PeopleDirectoryApp = lazy(() =>
  import('../containers/PeopleDirectoryApp'),
);

const PeopleDirectoryAppClient = ({ config }) => (
  <Suspense fallback={null}>
    <PeopleDirectoryApp config={config} />
  </Suspense>
);

export default PeopleDirectoryAppClient;
